import React, { createContext, useState, useContext, useEffect } from 'react';

const AppContext = createContext();

export const useAppContext = () => useContext(AppContext);

export const AppProvider = ({ children }) => {
    const expiryKey = 'app_expiry'; 
    const expiryTime = 82800000; 

    const isExpired = () => {
        const expiry = localStorage.getItem(expiryKey);
        if (!expiry) return false;

        const now = new Date().getTime();
        return now > parseInt(expiry, 10); 
    };

    const clearAllData = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('email');
        localStorage.removeItem('uni_id');
        localStorage.removeItem('user_id');
        localStorage.removeItem('kturu')
        localStorage.removeItem(expiryKey);
        window.location.href="https://ai.kesifaraci.com/login";
    };

    const initializeExpiry = () => {
        const now = new Date().getTime();
        localStorage.setItem(expiryKey, (now + expiryTime).toString());
    };

    useEffect(() => {

        // console.log(uniId);
        if (isExpired()) {
            clearAllData();
        }
    }, []);

    const [token, setToken] = useState(localStorage.getItem('token') || '');
    const [email, setEmail] = useState(localStorage.getItem('email') || '');
    const [uniId, setUniId] = useState(localStorage.getItem('uni_id') || '');
    const [userId, setUserId] = useState(localStorage.getItem('user_id') || '');
    const [kTuru, setKturu] = useState(localStorage.getItem('kturu') || '');

    const updateUserData = (newToken, newEmail, newUniId, newUserId, newKTuru) => {
        setToken(newToken);
        setEmail(newEmail);
        setUniId(newUniId);
        setUserId(newUserId);
        setKturu(newKTuru);
        localStorage.setItem('token', newToken);
        localStorage.setItem('email', newEmail);
        localStorage.setItem('uni_id', newUniId);
        localStorage.setItem('user_id', newUserId);
        localStorage.setItem('kTuru', newKTuru);

        initializeExpiry(); // Süreyi yeniden başlat
    };

    return (
        <AppContext.Provider value={{ token, email, uniId, userId, kTuru, updateUserData }}>
            {children}
        </AppContext.Provider>
    );
};
